export const Constants = {
  
  getProgressBarStyles: (value,threshold) => {
    return{
      pathColor: value >= threshold ? '#52C9A5' : '#fb5f5f',
      textColor: '#525252',
      trailColor: '#E7EBF8'
    };
  },
  getProgressBarInverseStyles: (value,threshold) => {
    return{
      pathColor: value <= threshold ? '#52C9A5' : '#fb5f5f',
      textColor: '#525252',
      trailColor: '#E7EBF8'
    };
  }
};